import { useSelector } from "react-redux";
import { Routes, Route, Navigate } from "react-router-dom";

import AdminUnloadingTablesSection from "./sections/adminUnloadingTablesSection";
import AdminUnloadingExcelSection from "./sections/adminUnloadingExcelSection";
import AdminUnloadingCronSection from "./sections/adminUnloadingCronSection";
import AdminUnloadingZipSection from "./sections/adminUnloadingZipSection";
import UnloadingExcelSection from "./sections/unloadingExcelSection";
import UnloadingZipSection from "./sections/unloadingZipSections";
import AdminUnloadingTemplateSection from "./sections/adminUnloadingTemplateSection";
import { IUserOptions } from "../../types/interfaces";

function UnloadingsApp() {
  const { data } = useSelector((state: IUserOptions) => state.user.user);
  const claims = data.claims;

  return (
    <Routes>
      {!data.isCustomer ? (
        <>
          {(claims.includes('admin') || claims.includes("orders:excel")) && (
            <Route path="/excel" element={<AdminUnloadingExcelSection />} />
          )}
          {(claims.includes('admin') || claims.includes("orders:zip")) && (
            <Route path="/zip" element={<AdminUnloadingZipSection />} />
          )}
          {(claims.includes('admin') || claims.includes("orders:cron")) && (
            <Route path="/cron" element={<AdminUnloadingCronSection />} />
          )}
          {(claims.includes('admin') || claims.includes("orders:payrolls")) && (
            <Route path="/tables" element={<AdminUnloadingTablesSection />} />
          )}
          {(claims.includes('admin') || (claims.includes('orders:import') && claims.includes("orders:excel"))) && (
          < Route path="/template" element={<AdminUnloadingTemplateSection />} />
          )}
          <Route path="*" element={<Navigate to="/page404" replace />} />
        </>
      ) : (
        <>
          <Route path="/excel" element={<UnloadingExcelSection />} />
          <Route path="/zip" element={<UnloadingZipSection />} />
        </>
      )}
    </Routes>
  );
}

export default UnloadingsApp;
